import React, { useEffect, useState } from "react";
import { useSelector as useReduxSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { languageIsEnglish } from "web/script/modules/language";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import { gettext } from "web/script/modules/django-i18n";
import CookieBanner from "web/react/components/cookie-banner/cookie-banner";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import styles from "./banner-container.css";

interface BannerContainerProps {
    cookieBanner: {
        cookie_policy_url: string;
    };
}

function followDesignerBannerState(state: ReduxStoreState): any {
    return state.followDesignerBannerReducer;
}

export default function BannerContainer({ cookieBanner }: BannerContainerProps): JSX.Element {
    const [isIos, setIsIos] = useState(false);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    const profile = useReduxSelector(followDesignerBannerState).profile;
    const showDUBanner = useReduxSelector(followDesignerBannerState).show;

    const pageSubType = environment.get("pageSubType");
    const enableIosToApp = environment.getFeature("mg_du_banner_ios_to_app");
    const isOnDesignerFeed = pageSubType && pageSubType.startsWith("designer");

    const sendIOSUsersToApp = isIos && enableIosToApp && isOnDesignerFeed;

    let followButtonProps = profile.follow_button
        ? {
              lystId: profile.follow_button.lyst_id,
              isAuthenticated: profile.follow_button.is_authenticated,
              isFollowing: profile.follow_button.is_following,
              description: sendIOSUsersToApp
                  ? profile.follow_button.ios_sticky_description
                  : profile.follow_button.description,
              notFollowedText:
                  enableIosToApp && isOnDesignerFeed
                      ? // 'Get Designer Updates'
                        gettext("designer_updates.get_designer_updates_btn_text")
                      : profile.follow_button.notfollowed_text,
              profileImage: profile.small_photo_url,
              followedText: profile.follow_button.followed_text,
          }
        : null;

    return (
        <div className={styles.container}>
            {languageIsEnglish() &&
                profile &&
                profile.follow_button &&
                profile.follow_button.is_authenticated != "true" && (
                    <FollowStickyBanner forceDisplay={showDUBanner} {...followButtonProps} />
                )}
            {cookieBanner && (
                <CookieBanner cookiePolicyUrl={cookieBanner.cookie_policy_url} debug={false} />
            )}
        </div>
    );
}
